import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const DollarIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      height={28}
      viewBox="0  0 18 28"
      width={18}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M9 .25a.75.75 0 0 1 .75.75v2.25H11A5.75 5.75 0 0 1 16.75 9a.75.75 0 0 1-1.5 0A4.25 4.25 0 0 0 11 4.75H9.75v8.5H12a5.75 5.75 0 0 1 0 11.5H9.75V27a.75.75 0 0 1-1.5 0v-2.25H6A5.75 5.75 0 0 1 .25 19a.75.75 0 0 1 1.5 0A4.25 4.25 0 0 0 6 23.25h2.25v-8.5H6.5a5.75 5.75 0 0 1 0-11.5h1.75V1A.75.75 0 0 1 9 .25Zm-.75 4.5H6.5a4.25 4.25 0 0 0 0 8.5h1.75v-8.5Zm1.5 10v8.5H12a4.25 4.25 0 0 0 0-8.5H9.75Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
